
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { documentStyles } from '../../../Styles/documentStyles';
import Images from '../../../Theme/Images';
import DocumentNavbar from '../DocumentNavbar';
import { ReactSVG } from 'react-svg'
import Loader from 'react-loader-spinner'
import DocumentDrawer from '../DocumentDrawer';
import Rector from '../Rector'
import PoSoForm from './PoSoForm';
import { SizeMe } from 'react-sizeme'

@inject('documentStore', 'imageStore')
@observer
class CurrentDocumentPoSo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resetImage: false
        }
        this._areaElement = new Map();
        this._areaElementBack = new Map();
    }

    componentDidMount() {
        this.props.documentStore.getDocumentDetails(this.props.match.params['documentId'])
       // if (this.props.location.documentId === undefined)
         //   this.props.history.push('/dashboard/drafts')
        this.props.documentStore.closeDocumentDrawer()
    }

    highlight = (event, index) => {
        const { currentDoc } = this.props.documentStore;
        this.fitPage()
        this.resetHighlight(false)
        const node = this._areaElement.get(index);
        const { currentWidthImage, getAspectRatio } = this.props.imageStore;
        const imgHeight = currentWidthImage * getAspectRatio;
        this.props.imageStore.zoomIn();
        this.props.imageStore.startDrawPoint(currentDoc.nonTabularData[index].pts && currentDoc.nonTabularData[index].pts[0] * currentWidthImage,
            currentDoc.nonTabularData[index].pts && currentDoc.nonTabularData[index].pts[1] * imgHeight,
            currentDoc.nonTabularData[index].pts && currentDoc.nonTabularData[index].pts[2] * currentWidthImage - currentDoc.nonTabularData[index].pts && currentDoc.nonTabularData[index].pts[0] * currentWidthImage,
            currentDoc.nonTabularData[index].pts && currentDoc.nonTabularData[index].pts[3] * imgHeight - currentDoc.nonTabularData[index].pts && currentDoc.nonTabularData[index].pts[1] * imgHeight,
            { width: currentWidthImage - currentDoc.nonTabularData[index].pts && currentDoc.nonTabularData[index].pts[0] * currentWidthImage, height: imgHeight - currentDoc.nonTabularData[index].pts && currentDoc.nonTabularData[index].pts[1] * imgHeight }, currentDoc.nonTabularData[index].pts,
            { w: currentWidthImage, h: imgHeight });
    }

    highlightTabularData = (event, index) => {
        const { currentPage, currentDoc } = this.props.documentStore;
        this.fitPage()
        this.resetHighlight(false)
        const node = this._areaElement.get(index);
        const { currentWidthImage, getAspectRatio } = this.props.imageStore;
        const imgHeight = currentWidthImage * getAspectRatio;
        this.props.imageStore.zoomIn();
        this.props.imageStore.startDrawPoint(currentPage.tableData[index].pts[0] * currentWidthImage,
            currentPage.tableData[index].pts[1] * imgHeight,
            currentPage.tableData[index].pts[2] * currentWidthImage - currentPage.tableData[index].pts[0] * currentWidthImage,
            currentPage.tableData[index].pts[3] * imgHeight - currentPage.tableData[index].pts[1] * imgHeight,
            { width: currentWidthImage - currentPage.tableData[index].pts[0] * currentWidthImage, height: imgHeight - currentPage.tableData[index].pts[1] * imgHeight }, currentPage.tableData[index].pts,
            { w: currentWidthImage, h: imgHeight });
    }

    highlightBack = (event, index) => {
        const { currentDoc } = this.props.documentStore
        this.resetHighlight(false)
        const node = this._areaElementBack.get(index);
        const { currentWidthImage, getAspectRatioBack } = this.props.imageStore;
        const imgHeight = currentWidthImage * getAspectRatioBack;

        if (node.props.newlyCreated) {
            this.props.imageStore.startDrawPoint(currentDoc.nonTabularData[index].pts[0],
                currentDoc.nonTabularData[index].pts[1], currentDoc.nonTabularData[index].pts[2],
                currentDoc.nonTabularData[index].pts[3], { width: currentWidthImage, height: imgHeight }, currentDoc.nonTabularData[index], { w: currentWidthImage, h: imgHeight });
        } else {
            this.props.imageStore.startDrawPoint(currentDoc.nonTabularData[0] * currentWidthImage,
                currentDoc.nonTabularData[index].pts[1] * imgHeight,
                currentDoc.nonTabularData[index].pts[2] * currentWidthImage - currentDoc.nonTabularData[index].pts[0] * currentWidthImage,
                currentDoc.nonTabularData[index].pts[3] * imgHeight - currentDoc.nonTabularData[index].pts[1] * imgHeight,
                { width: currentWidthImage, height: imgHeight }, currentDoc.nonTabularData[index], { w: currentWidthImage, h: imgHeight }
            );
        }
    }

    resetHighlight(reset) {
        this.setState({
            resetImage: reset
        })
    }

    removeHighlight = (event, index) => {
        this.resetHighlight(true)
        const node = this._areaElement.get(index);
        this.props.imageStore.eraseDrawPoint();
    }

    openDropDown = () => {
        this.props.imageStore.openDocumentDrawer()
    }

    zoomIn = () => {
        if (this.props.documentStore.currentField._id !== undefined)
            this.props.imageStore.zoomIn()
    }

    zoomOut = () => {
        if (this.props.documentStore.currentField._id !== undefined)
            this.props.imageStore.zoomOut()
    }

    fitPage = () => {
        if (this.props.documentStore.currentField._id !== undefined)
            this.props.imageStore.fitPage()
    }

    render() {
        const { classes } = this.props;
        const { currentPage, currentDoc, inProgress, currentField } = this.props.documentStore;

        if (inProgress)
            return (
                <div className={classes.loaderDiv}><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
            )

        return (
            currentDoc.pageArray && currentDoc.pageArray.length ? <div>
                {currentDoc.docStatus === "REVIEW_PENDING" ? <DocumentDrawer></DocumentDrawer> : null}
                <div className={classes.content} style={{ display: 'flex' }}>
                    <PoSoForm resetImage={this.fitPage} highlight={this.highlight} removeHighlight={this.removeHighlight} highlightTabularData={this.highlightTabularData}></PoSoForm>
                    <div className={classes.imageDiv}>
                        <SizeMe>{({ size }) =>
                            <div className={classes.imageContainer} id="rector-container">
                                <Rector type="poso" resetImage={false} imageContainerWidth={size.width} imageContainerHeight={currentPage.dimension.height / currentPage.dimension.width * (size.width)}
                                    width={currentPage.dimension.width} height={currentPage.dimension.height}
                                    aspectRatio={currentPage.dimension.height / currentPage.dimension.width} imageSrc={currentPage.pageImageLink} onSelected={this.onSelected} />
                                <div className={classes.pageNo}>
                                    Page {currentPage.pageNo}
                                </div>
                                {currentField._id !== undefined ?
                                    <div className={classes.zoomContainer}>
                                        <ReactSVG
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.zoomIn()}
                                            src={Images.zoomIn} />
                                        <ReactSVG
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.zoomOut()}
                                            src={Images.zoomOut} />
                                        <ReactSVG disabled
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            onClick={(e) => this.fitPage()}
                                            src={Images.fitPage} />
                                    </div> : null}
                            </div>
                        }</SizeMe>
                    </div>
                </div>
                <DocumentNavbar type='poso' resetImage={this.fitPage}></DocumentNavbar>
            </div> : null

        )
    }
}
export default withStyles(documentStyles, { withTheme: true })(withRouter(CurrentDocumentPoSo));
